/**
 * Hanlyn Quick Shop Drawer Initializer
 *
 * Intercepts Dawn's quick-add modal buttons and redirects them to open the drawer instead.
 * This script wires up the drawer to existing quick-add buttons without modifying Dawn's core JS.
 */

(function() {
  'use strict';

  /**
   * Initialize drawer functionality
   */
  function initQuickShopDrawer() {
    const drawer = document.querySelector('hanlyn-quick-shop-drawer');

    if (!drawer) {
      console.warn('HanlynQuickShopDrawer: Drawer element not found. Make sure hanlyn-quick-shop-drawer snippet is included in theme.liquid.');
      return;
    }

    // Wait for drawer custom element to be defined
    customElements.whenDefined('hanlyn-quick-shop-drawer').then(() => {
      setupModalOpenerInterception(drawer);
    });
  }

  /**
   * Set up interception of modal-opener clicks
   */
  function setupModalOpenerInterception(drawer) {
    // Use event delegation on document to catch all modal-opener clicks
    document.addEventListener('click', function(event) {
      // Find the closest modal-opener element
      const modalOpener = event.target.closest('modal-opener');

      if (!modalOpener) return;

      // Find the button inside modal-opener that has data-product-url
      const button = modalOpener.querySelector('button[data-product-url]');

      if (!button) return;

      // Check if this is a quick-add button (not other modal types)
      const modalId = modalOpener.getAttribute('data-modal');
      if (!modalId || !modalId.includes('QuickAdd')) return;

      // Get the product URL from the button
      const productUrl = button.getAttribute('data-product-url');

      if (!productUrl) return;

      // Prevent default modal behavior
      event.preventDefault();
      event.stopPropagation();

      // Open the drawer instead of the modal
      drawer.open(button, productUrl);
    }, true); // Use capture phase to intercept before Dawn's listeners
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickShopDrawer);
  } else {
    initQuickShopDrawer();
  }
})();
